import React, { useEffect } from "react";

export default function DeletePolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-content">
      <div className="container privacy-wrapper py-5 text-start">
        <div className="wrapper pb-4">
          <h1>Delete Policy</h1>
          <h2 className="h4 mt-3">Account Deletion and Data Removal</h2>
        </div>

        <div className="wrapper pb-4">
          <h4>1. Requesting Account Deletion</h4>
          <p>
            You can request deletion of your PollSphere account at any time from your
            account settings or by contacting support. After we verify your request,
            your account will be marked for deletion.
          </p>
        </div>

        <div className="wrapper pb-4">
          <h4>2. What Data Is Deleted</h4>
          <p>
            We remove or anonymize personal information associated with your profile,
            including contact details and account identifiers, unless retention is
            required by applicable law.
          </p>
        </div>

        <div className="wrapper pb-4">
          <h4>3. Retention Exceptions</h4>
          <p>
            Certain records may be retained for legal, regulatory, fraud prevention,
            accounting, or dispute resolution purposes for a limited period.
          </p>
        </div>

        <div className="wrapper pb-4">
          <h4>4. Processing Timeline</h4>
          <p>
            Most deletion requests are completed within 30 days. Complex cases or
            legal review requirements may extend this timeline.
          </p>
        </div>

        <div className="wrapper">
          <h4>5. Contact</h4>
          <p>
            If you have questions regarding account deletion, please contact the
            PollSphere support team.
          </p>
        </div>
      </div>
    </div>
  );
}
